document.addEventListener('DOMContentLoaded', () => {

  const flavorRows = document.querySelectorAll('.flavorRow');
  const bundleDivs = document.querySelectorAll('.bundle-index');

  flavorRows.forEach((row, rowIndex) => {
    const radios = row.querySelectorAll('input[type="radio"]');
    const bundleDiv = bundleDivs[rowIndex];
    if (!bundleDiv) return;

    const images = bundleDiv.querySelectorAll('img');

    const updateImages = () => {
      images.forEach(img => (img.style.display = 'none'));
      radios.forEach((radio, radioIndex) => {
        if (radio.checked && images[radioIndex]) {
          images[radioIndex].style.display = 'block';
        }
      });
    };

    // hide all images on page load
    images.forEach(img => (img.style.display = 'none'));

    // show selected image if one is checked on load
    updateImages();

    // attach listeners
    radios.forEach(radio => {
      radio.addEventListener('change', updateImages);
    });
  });

});